import type { HelpFile } from '../../types/help'
import { JobBreadcrumbsTestIds } from '../../../testids/JobBreadcrumbsTestIds'

export const jobBreadcrumbsHelp: HelpFile = {
  docPage: '/docs/jobs/job-scheduler',
  texts: {
    [JobBreadcrumbsTestIds.jobBreadcrumbs]:
      'Breadcrumb-Pfad durch die Job-Hierarchie — übergeordneter Job, Kind-Ausführungen und aktueller Schritt.',
  },
}
